import * as modelsGet from "../models/get";
import { getCalendars } from "../api/calendars";

var calendars: modelsGet.ICalendar[];

/**
 * Gibt alle Kalendergruppen zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getCalendarsAsync(reload: boolean = false): Promise<modelsGet.ICalendar[]>
{
    if (calendars == null || reload)
    {
        calendars = await getCalendars();
    }

    return calendars;
}